import { IRtpFundingDetails } from '../../interfaces/lmt/rtp-funding-details.interface';

export abstract class AbstractFundingDetailsService {
  abstract getRtpFundingDetails(): Promise<IRtpFundingDetails | undefined>;
}
